<i18n>
  {
    "pt_BR": {
      "to": "Para",
      "name": "Nome",
      "body": "Corpo da mensagem",
      "stage": "Estágio",
      "company": "Empresa",
      "campaign": "Campanha",
      "created_at": "Data da mensagem (enviada / recebida)",
      "status_identifier": "Estado da mensagem"
    }
  }
</i18n>

<template>
  <div>
    <h4 class="details-table--title" v-text="title" v-if="title"></h4>

    <template v-if="fetched">
      <vue-good-table
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-search="onSearch"
        @on-per-page-change="onPerPageChange"
        :columns="columns"
        :totalRows="total"
        :rows="list"
        :isLoading.sync="loading"
        v-bind="table"
        >
        <div slot="table-actions" v-if="csv && list.length">
          <button @click.prevent="download">
            <span v-text="generating ? 'Exportando...' : 'Exportar estes resultados'"></span>
          </button>
        </div>
      </vue-good-table>
    </template>

    <template v-else-if="fetched === false">
      <div class="details-not-sent">
        <p class="details-not-sent--text" v-text="empty"></p>
      </div>
    </template>

    <Status :status="fetched" v-else />
  </div>
</template>

<script>
  import Status from '@/Status';
  import Axios from 'core/axios';
  import { debounce } from 'lodash';

  const format = (header, row) => header.map((key) => {
    const item = row[key];

    if (typeof item !== 'string' || item.indexOf(',') === -1) {
      return item || '';
    }

    return `"${item}"`;
  }).join(',');

  export default {
    components: {
      Status,
    },

    props: {
      title: {
        type: String,
        required: false,
      },

      empty: {
        type: String,
        required: true,
      },

      route: {
        type: String,
        required: true,
      },

      columns: {
        type: Array,
        required: true,
      },

      csv: {
        type: Boolean,
        required: false,
        default: true,
      },

      extra: {
        type: Object,
        required: false,
        default: () => ({}),
      },
    },

    computed: {
      table () {
        return {
          mode: 'remote',

          'search-options': {
            enabled: true,
            placeholder: 'Pesquisar pelo nome ou telefone',
          },

          'sort-options': {
            enabled: true,
            initialSortBy: {
              field: 'created_at',
              type: 'desc',
            },
          },

          'pagination-options': {
            enabled: true,
            mode: 'records',
            perPage: 20,
            position: 'top',
            perPageDropdown: [20, 100, 200, 500, 1000, 5000],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'Próximo',
            prevLabel: 'Anterior',
            rowsPerPageLabel: 'Resultados por página',
            ofLabel: 'of',
          },
        };
      },
    },

    data: () => ({
      fetched: null,
      loading: false,
      data: [],
      total: 0,
      page: 1,
      sort: 'desc',
      field: 'created_at',
      search: '',
      per_page: 20,
      generating: false,
    }),

    created () {
      this.fetch(true);
    },

    methods: {
      onPageChange ({ currentPage }) {
        this.page = currentPage;
        this.fetch();
      },

      onPerPageChange ({ currentPerPage }) {
        this.page = 1;
        this.per_page = currentPerPage;
        this.fetch();
      },

      onSortChange ({ sortType, columnIndex }) {
        this.sort = sortType;
        this.field = this.columns[columnIndex].field;
        this.fetch();
      },

      onSearch: debounce(function ({ searchTerm }) {
        this.search = searchTerm;
        this.fetch();
      }, 300),

      fetch (first = false) {
        const {
          list,
          ...rest,
        } = this.$data;

        const params = Object.assign({}, this.extra, rest);

        this.loading = ! first;

        return Axios.get(this.route, {
          params,
        })
          .then(({ data }) => {
            this.list = data.data;
            this.total = data.total;

            if (this.fetched === null) {
              this.fetched = this.list.length !== 0;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },

      download () {
        if (this.generating) {
          return;
        }

        this.generating = true;

        setTimeout(() => {
          const keys = this.columns.map(({ field }) => field);
          const csv = this.list.map(row => format(keys, row));

          csv.unshift(this.columns.map(({ label }) => label).join(','));

          const data = encodeURI('data:text/csv;charset=utf-8,' + csv.join('\n'));

          const link = document.createElement('a');
          link.setAttribute('href', data);
          link.setAttribute('download', 'export.csv');

          document.body.appendChild(link);

          link.click();

          document.body.removeChild(link);

          this.generating = false;
        }, 10);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Campaign/Table.vue